import React from 'react';
import Styles from './styles.module.scss';
import { Skeleton } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { InfoIconToolTip } from '../../../UI/InfoIconToolTip/InfoIconToolTip';

export interface IItemProps {
    id: string;
    label: string;
    value?: string;
    icon?: React.ReactNode;
    loading?: boolean;
    noDataMessage?: string;
    tooltip: string;
    allVenues?: boolean;
}

const TotalsListItem = (props: IItemProps) => {
    const { t } = useTranslation();
    return (
        <div className={Styles.Card}>
            <div className={Styles.Title}>
                <div className={Styles.Icon}>{props.icon}</div>
                <div className={Styles.FlexWrapper}>
                    <div className={Styles.TitleText}>{t(props.label)}</div>
                    <InfoIconToolTip
                        infoMessage={
                            props.allVenues ? t(`misc.Overview.${props.tooltip}`) : t(`misc.Analytics.${props.tooltip}`)
                        }
                    />
                </div>
            </div>
            <div className={Styles.Value}>
                {props.loading ? (
                    <div className={Styles.Loading}>
                        <Skeleton width="50%" height="16px" style={{ borderRadius: '16px' }} />
                    </div>
                ) : props.value ? (
                    <span>{props.value}</span>
                ) : (
                    <span className={Styles.NoData}>{props.noDataMessage ? props.noDataMessage : 'No Data'}</span>
                )}
            </div>
        </div>
    );
};

export default TotalsListItem;
